import { createFileRoute, redirect } from '@tanstack/react-router'
import { meQuery } from '../lib/api.ts'
import { authorizeContinuation, rawOAuthQuery } from '../lib/mcp.ts'

/**
 * Better Auth's `loginPage` for MCP clients (ADR 0009): without a session → normal login with the authorize
 * request as redirect target; with a session (e.g. after the login) → straight back to the authorize request.
 */
export const Route = createFileRoute('/oauth/login')({
  beforeLoad: async ({ context }) => {
    const target = authorizeContinuation(rawOAuthQuery('/oauth/login'))
    if (!target) throw redirect({ to: '/' })
    const me = await context.queryClient.ensureQueryData(meQuery)
    if (me) {
      window.location.replace(target)
      return
    }
    throw redirect({ to: '/login', search: { redirect: target } })
  },
  component: () => null,
})
